module.exports = require("clean-stack");


//////////////////
// WEBPACK FOOTER
// external "clean-stack"
// module id = 102
// module chunks = 0 1 2